/**
 * Bundle Mode Detection Utilities
 *
 * Apps can use these to detect if they're running in bundle mode
 * and adjust behavior accordingly (e.g., disable redirects)
 */

declare global {
  interface Window {
    __ROOM_BUNDLE_MODE__?: boolean;
  }
}

/**
 * Check if currently running in bundle mode
 * @returns true if app is loaded as bundle in overlay, false if standalone page
 */
export function isBundleMode(): boolean {
  return Boolean(window.__ROOM_BUNDLE_MODE__);
}

/**
 * Check if app should allow redirects
 * In bundle mode, redirects are disabled to prevent breaking the overlay
 * @returns true if redirects are allowed
 */
export function shouldAllowRedirects(): boolean {
  return !isBundleMode();
}
